import { Link, useLang } from '../i18n';
import SEO from '../components/SEO';
import { SITE_URL } from '../data/siteData';

export default function NotFoundPage() {
  const { t } = useLang();
  return (
    <>
      <SEO title={t('Página no encontrada', 'Pàgina no trobada')} description={t('La página que buscas no existe o se ha movido.', 'La pàgina que cerques no existeix o s\'ha mogut.')} canonical={`${SITE_URL}/404`} robots="noindex, follow" />
      <section className="page-hero">
        <div className="container text-center">
          <span className="section-label">ERROR 404</span>
          <h1 className="page-hero-title">{t('Esta página no está disponible', 'Aquesta pàgina no està disponible')}</h1>
          <p className="page-hero-sub">{t('Puedes volver al inicio o consultar nuestras clases de inglés.', 'Pots tornar a l\'inici o consultar les nostres classes d\'anglès.')}</p>
          <div className="cta-btns mt-40"><Link to="/" className="btn-primary">{t('Volver al inicio', 'Tornar a l\'inici')}</Link><Link to="/clases" className="btn-outline">{t('Ver clases', 'Veure classes')}</Link></div>
        </div>
      </section>
    </>
  );
}
